export const filelist = [
    {
        value: "Sessionseinladung",
        link: "/protocols/20251024/1_Sessionseinladung.pdf"
    },
    {
        value: "Beilagenblatt",
        link: "/protocols/20251024/2_Beilagenblatt.pdf"
    },
    {
        value: "Voranschlag KVS 2026",
        link: "/protocols/20251024/3_Voranschlag_KVS_2026.pdf"
    },
    {
        value: "Voranschlag KAS 2026",
        link: "/protocols/20251024/4_Voranschlag_KAS_2026.pdf"
    },
    {
        value: "Voranschlag ASS 2026",
        link: "/protocols/20251024/5_Voranschlag_ASS_2026.pdf"
    },
    {
        value: "Bericht zum Voranschlag 2026",
        link: "/protocols/20251024/6_Bericht_zum_Voranschlag_2026.pdf"
    },
    {
        value: "GPK Antrag Voranschlag 2026",
        link: "/protocols/20251024/7_GPK_Antrag_Voranschlag_2026.pdf"
    },
    {
        value: "Finanzplanung 2026-2029",
        link: "/protocols/20251024/8_Finanzplanung_2026-2029.pdf"
    },
    {
        value: "Finanzausgleich 2026",
        link: "/protocols/20251024/9_Finanzausgleich_2026.pdf"
    },
    {
        value: "Finanzausgleich 2018-2026 Varianten",
        link: "/protocols/20251024/10_Finanzausgleich_2018-2026_Varianten.pdf"
    },
]